import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactImageMagnify from 'react-image-magnify';
import { useImage, useResizeListener } from './useImage';
import { UX2 } from '@wsb/guac-widget-core';
import imageCropOptions from '../../../../constants/imageCropOptions';

function ImageZoom(props) {
  const {
    alt,
    containerId,
    cropMethod,
    disableZoom,
    enlargedImagePosition,
    imageClassName,
    maxHeight,
    maxWidth,
    renderCallback,
    src,
    srcLarge,
    style = {},
    zoomDimensions = [],
    aspectRatio
  } = props;

  const expandToFill = cropMethod === imageCropOptions.EXPAND_TO_FILL;
  const shrinkToFit = cropMethod === imageCropOptions.SHRINK_TO_FIT;
  const enlargedImageContainerStyle = useMemo(
    () => ({
      backgroundColor: '#fff',
      ...style,
      zIndex: 999
    }),
    [style]
  );
  const styles = {
    width: 'auto'
  };

  const { width, height, source, zoom, loading } = useImage({
    aspectRatio,
    containerId,
    disableZoom,
    expandToFill,
    zoomDimensions,
    srcLarge,
    maxHeight,
    maxWidth,
    src
  });

  useResizeListener(renderCallback);

  if (!props.src || loading) {
    return null;
  }

  if (disableZoom || !zoom) {
    const { Image } = UX2.Element;
    const imageProps = { src: source, alt, width, height };
    return shrinkToFit ? <Image { ...imageProps } style={ styles } /> : <Image { ...imageProps } />;
  }

  const reactImageMagnifyProps = {
    largeImage: { alt: alt, ...zoom },
    smallImage: { alt, isFluidWidth: false, src: source, width, height },
    isActivatedOnTouch: true,
    enlargedImagePosition: enlargedImagePosition || 'beside',
    enlargedImageContainerStyle,
    enlargedImageContainerClassName: 'image-zoom',
    imageClassName
  };

  return <ReactImageMagnify { ...reactImageMagnifyProps } />;
}

ImageZoom.propTypes = {
  alt: PropTypes.string,
  aspectRatio: PropTypes.number,
  containerId: PropTypes.string,
  cropMethod: PropTypes.string,
  disableZoom: PropTypes.bool,
  enableEnlargedImageContainer: PropTypes.bool,
  enlargedImagePosition: PropTypes.string,
  imageClassName: PropTypes.string,
  maxHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  renderCallback: PropTypes.any,
  src: PropTypes.string,
  srcLarge: PropTypes.string,
  style: PropTypes.object,
  zoomDimensions: PropTypes.array
};

export default ImageZoom;
